import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserRoleOptions } from "../../constants/userRole";

const bannertitle = "Introducing HotAdultHub";
const bannerdesc = (
  <p>
    Serious Dating With <strong>HotAdultHub </strong> Your Perfect Match is Just aa
    Click Away.
  </p>
);

const BannerSection = () => {
  const navigate = useNavigate();

  // State for form values
  const [formData, setFormData] = useState({
    gender: "",
    lookingFor: "",
    ageStart: "18",
    ageEnd: "30",
    // city: "",
  });

  // Handle select/input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // On submit, prevent default and navigate with state
  const handleSubmit = (e) => {
    e.preventDefault();
    // navigate to /members and pass form data via state
    navigate("/members", { state: formData });
  };

  return (
    <section className="banner-section">
      <div className="container">
        <div className="section-wrapper">
          <div className="row align-items-end">
            <div className="col-lg-6">
              <div className="banner-content">
                <div className="intro-form">
                  <div className="intro-form-inner">
                    <h3>{bannertitle}</h3>
                    {bannerdesc}
                    <form onSubmit={handleSubmit} className="banner-form">
                      <div className="gender">
                        <label className="left">I am a </label>
                        <div className="custom-select right">
                          <select
                            name="gender"
                            value={formData.gender}
                            onChange={handleChange}
                          >
                            <option value="">Select Favourite</option>
                            {UserRoleOptions.map(({ value, label }) => (
                              <option key={value} value={value}>
                                {label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="person">
                        <label className="left">Looking for</label>
                        <div className="custom-select right">
                          <select
                            name="lookingFor"
                            value={formData.lookingFor}
                            onChange={handleChange}
                          >
                            <option value="">Select Favourite</option>
                            {UserRoleOptions.map(({ value, label }) => (
                              <option key={value} value={value}>
                                {label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="age">
                        <label className="left">Age</label>
                        <div className="right d-flex justify-content-between">
                          <div className="custom-select">
                            <select
                              name="ageStart"
                              value={formData.ageStart}
                              onChange={handleChange}
                            >
                              {[...Array(13)].map((_, i) => {
                                const age = 18 + i;
                                return (
                                  <option key={age} value={age}>
                                    {age}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                          <div className="custom-select">
                            <select
                              name="ageEnd"
                              value={formData.ageEnd}
                              onChange={handleChange}
                            >
                              {[...Array(13)].map((_, i) => {
                                const age = 18 + i;
                                return (
                                  <option key={age} value={age}>
                                    {age}+
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* <div className="city">
                        <label className="left">City</label>
                        <input
                          className="right"
                          type="text"
                          name="city"
                          value={formData.city}
                          onChange={handleChange}
                          placeholder="Your City Name.."
                        />
                      </div> */}

                      <button type="submit">Find Your Partner</button>
                    </form>

                    {/* Social list... */}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="banner-thumb">
                <img src="assets/images/banner/01.png" alt="img" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="all-shapes">
        {[...Array(8)].map((_, i) => (
          <img
            key={i}
            src={`assets/images/banner/banner-shapes/0${i + 1}.png`}
            alt="shape"
            className={`banner-shape shape-${i + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default BannerSection;
